// SLA and "under review" for the Onboarding list (DEV-160).
//
// The server decides which applications are under review and counts their
// days, so the column survives paging; this only turns the count into the
// chip a reviewer reads. The bands are the ones the removed KYC Queue used.

import {
  UNDER_REVIEW_FILTER,
  type ApplicationStatus,
  type ApplicationStatusFilter,
} from '../../api/onboarding.api.js';

/** Days waiting from which the chip turns amber, then red. */
export const SLA_AMBER_DAYS = 1;
export const SLA_RED_DAYS = 3;

export type SlaTone = 'success' | 'warning' | 'error';

export function slaTone(days: number): SlaTone {
  if (days >= SLA_RED_DAYS) return 'error';
  if (days >= SLA_AMBER_DAYS) return 'warning';
  return 'success';
}

/** "0 days", "1 day", "5 days": what the SLA chip says. */
export function slaLabel(days: number): string {
  return days === 1 ? '1 day' : `${String(days)} days`;
}

export const APPLICATION_STATUSES: readonly ApplicationStatus[] = [
  'IN_PROGRESS',
  'SUBMITTED',
  'APPROVED',
  'DECLINED',
  'INFO_REQUESTED',
];

/** A status from the address bar, or '' (all) when it is not one we know. */
export function statusFilterFromQuery(value: string | null): ApplicationStatusFilter | '' {
  if (value === UNDER_REVIEW_FILTER) return UNDER_REVIEW_FILTER;
  return APPLICATION_STATUSES.includes(value as ApplicationStatus) ? (value as ApplicationStatus) : '';
}
